// Shared layout primitives for the /kurz webinar landing page, matching
// proposals/webinare_v2/styles-v2.css (.container / .section-head / .eyebrow).

export const Container = ({ children, className = '' }) => (
  <div className={`mx-auto w-full max-w-[1224px] px-6 ${className}`.trim()}>{children}</div>
);

export const SectionHead = ({ eyebrow, heading, intro, dark = false }) => (
  <div className="mb-12 max-w-[640px]">
    {eyebrow && (
      <div
        className={`inline-flex items-center gap-2 text-sm font-semibold tracking-[0.08em] uppercase ${
          dark ? 'text-brand-400' : 'text-brand-500'
        }`}
      >
        {eyebrow}
      </div>
    )}
    {heading && (
      <h2
        className={`mt-4 font-poly text-[28px] leading-[1.2] font-light md:text-[48px] ${
          dark ? 'text-white' : 'text-grey-950'
        }`}
      >
        {heading}
      </h2>
    )}
    {intro && <p className={`mt-4 text-base leading-[1.6] ${dark ? 'text-white/65' : 'text-grey-500'}`}>{intro}</p>}
  </div>
);
